import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Col, Row, Spinner } from "react-bootstrap";
import PgCard from "src/components/Card/PgCard";
import { useHubCardLivePreview } from "src/hooks/useHubCardLivePreview";
import { entertainmentHeading, mapEntertainmentEvent } from "src/utils/mapEntertainment";
import { entertainmentLivePreviewRequestHandler } from "src/utils/entertainmentLivePreviewHandler";

const buildButtonSettings = (card, t) => {
  if (!card?.event_url && !card?.ticket_url) return null;

  if (card.event_url && card.ticket_url) {
    return [
      {
        href: card.event_url,
        label: t("button.read-more"),
      },
      {
        href: card.ticket_url,
        label: t("entertainment.buyTickets"),
      },
    ];
  }

  return {
    href: card.event_url || card.ticket_url,
    label: card.event_url ? t("button.read-more") : t("entertainment.buyTickets"),
  };
};

const EntertainmentCardPreview = () => {
  const { t, i18n } = useTranslation();
  const { card, isLoading } = useHubCardLivePreview(
    "entertainment",
    {
      depth: 1,
      mapDoc: mapEntertainmentEvent,
      requestHandler: entertainmentLivePreviewRequestHandler,
      getDocId: (doc) => doc?.id ?? doc?.name,
    },
    i18n.language
  );

  return (
    <PreviewPage>
      <container-wide>
        <Row className="g-4 justify-content-center" xs={1}>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center w-100 py-5">
              <Spinner animation="border" variant="light" role="status">
                <span className="visually-hidden">{t("loading")}</span>
              </Spinner>
            </div>
          ) : !card ? (
            <div className="preview-status py-5 w-100">
              <p>{t("entertainment.preview.waitingForDocument")}</p>
            </div>
          ) : (
            <Col xs={12} md={10} lg={8} xl={6}>
              <PgCard
                image={card.image}
                imageAlt={card.imageAlt || entertainmentHeading(card)}
                title={entertainmentHeading(card)}
                subtitle={card.event_info}
                text={card.text}
                buttonSettings={buildButtonSettings(card, t)}
              />
            </Col>
          )}
        </Row>
      </container-wide>
    </PreviewPage>
  );
};

const PreviewPage = styled.div`
  padding: 1.5rem 0 2rem;
  min-height: 100vh;
  background: var(--black);
  color: var(--white);

  .preview-status {
    text-align: center;
    color: var(--mutedwhite);
  }

  .pg-card {
    .card-header {
      flex-grow: 0;
    }
    .card-body {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      .card-text {
        flex-grow: 1;
      }
    }
  }
`;

export default EntertainmentCardPreview;
